import styles from "./TextareaInput.module.css";

export default function TextareaInput({ inputProps, controlProps, slotProps }) {
	return (
		<div {...controlProps}>
			<textarea
				{...inputProps}
				rows={inputProps.rows ?? 4}
				{...slotProps("field", styles.field)}
			/>
		</div>
	);
}
